// Spieleranzahl für Übungen (numerisch statt Freitext)

/** @type {readonly number[]} */
export const DRILL_PLAYER_COUNT_OPTIONS = [1, 2, 3, 4];

/**
 * @param {unknown} value
 * @returns {number[]}
 */
export function normalizeIdealPlayerCounts(value) {
  const raw = Array.isArray(value) ? value : [];
  const nums = raw
    .map((n) => Number(n))
    .filter((n) => Number.isFinite(n) && n >= 1 && n <= 4);
  const unique = [...new Set(nums)].sort((a, b) => a - b);
  return unique.length > 0 ? unique : [2];
}

/**
 * @param {unknown} text
 * @returns {{ counts: number[], overFour: boolean }}
 */
export function parseLegacyGroupSize(text) {
  const s = String(text || "").trim();
  if (!s) return { counts: [2], overFour: false };

  const range = s.match(/(\d+)\s*[–\-—]\s*(\d+)/);
  if (range) {
    const a = Number(range[1]);
    const b = Number(range[2]);
    const lo = Math.min(a, b);
    const hi = Math.max(a, b);
    const counts = [];
    for (let i = Math.max(1, lo); i <= Math.min(4, hi); i += 1) counts.push(i);
    return {
      counts: normalizeIdealPlayerCounts(counts),
      overFour: hi > 4 || />|über|mehr als/i.test(s),
    };
  }

  const nums = (s.match(/\d+/g) || [])
    .map((x) => Number(x))
    .filter((n) => Number.isFinite(n) && n >= 1);
  const inRange = nums.filter((n) => n <= 4);
  const overFour = nums.some((n) => n > 4) || />|über|mehr als/i.test(s);
  if (inRange.length > 0) {
    return { counts: normalizeIdealPlayerCounts(inRange), overFour };
  }
  return { counts: [2], overFour };
}

/**
 * @param {object | null | undefined} drill
 * @param {(key: string) => string} [t]
 * @returns {{ counts: number[], overFour: boolean }}
 */
export function resolveDrillIdealPlayerCounts(drill, t) {
  if (
    Array.isArray(drill?.idealPlayerCounts) &&
    drill.idealPlayerCounts.length > 0
  ) {
    return {
      counts: normalizeIdealPlayerCounts(drill.idealPlayerCounts),
      overFour: drill.idealOverFour === true,
    };
  }
  const override = String(drill?.groupSizeOverride || "").trim();
  if (override) return parseLegacyGroupSize(override);
  const key = String(drill?.groupSizeKey || "").trim();
  if (key && typeof t === "function") {
    const translated = String(t(key) || "").trim();
    if (translated && translated !== key)
      return parseLegacyGroupSize(translated);
  }
  return { counts: [2], overFour: false };
}

/**
 * @param {(key: string, params?: Record<string, string>) => string} t
 * @param {{ counts: number[], overFour: boolean }} model
 */
export function formatIdealPlayerCounts(t, model) {
  const counts = normalizeIdealPlayerCounts(model?.counts);
  const parts = counts.map(String).join(", ");
  let out = t("trainer.drills.playerCounts.idealFor", { counts: parts });
  if (model?.overFour) {
    out = `${out} · ${t("trainer.drills.playerCounts.overFour")}`;
  }
  return out;
}

/**
 * Spielerzahlen > 2, für die Variations-Anpassungen sinnvoll sind.
 *
 * @param {{ counts: number[], overFour: boolean }} model
 * @returns {Array<number | 'over4'>}
 */
export function adaptationPlayerSlots(model) {
  const slots = normalizeIdealPlayerCounts(model?.counts).filter((n) => n > 2);
  if (model?.overFour) slots.push("over4");
  return slots;
}
